export default __webpack_public_path__ + "static/media/e9ca37cdab222f9a.94639ebcf735df5f6aceebad4f4aec74.svg";